import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-01bd4b92"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "com-form"
};
const _hoisted_2 = {
  key: 0,
  class: "form-item-intro"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");

  const _component_el_option = _resolveComponent("el-option");

  const _component_el_select = _resolveComponent("el-select");

  const _component_el_date_picker = _resolveComponent("el-date-picker");

  const _component_el_cascader = _resolveComponent("el-cascader");

  const _component_el_input_number = _resolveComponent("el-input-number");

  const _component_van_field = _resolveComponent("van-field");

  const _component_van_cascader = _resolveComponent("van-cascader");

  const _component_van_popup = _resolveComponent("van-popup");

  const _component_el_form_item = _resolveComponent("el-form-item");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
    ref: "form",
    model: $setup.formData,
    rules: $setup.formRules
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      gutter: $props.config.gutter || 10
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fields, (field, fieldIndex) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_col, {
          key: field.name,
          span: field.span || $props.config.span || 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: field.label ? `${field.label}:` : undefined,
            "label-width": field.labelWidth || $props.config.labelWidth || '90px',
            prop: field.name
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass({
                'form-item-content': true,
                'item-content__textarea': field.type === 'textarea'
              })
            }, [['text', 'textarea', 'password'].includes(field.type) ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: $setup.formData[field.name],
              "onUpdate:modelValue": $event => $setup.formData[field.name] = $event,
              modelModifiers: {
                trim: true
              },
              type: field.type,
              size: field.size,
              disabled: field.disabled,
              readonly: field.readonly,
              placeholder: field.placeholder || `请输入${field.label || ''}`,
              clearable: field.clearable,
              maxlength: field.maxlength,
              minlength: field.minlength,
              "show-word-limit": field.showWordLimit,
              rows: field.rows,
              autosize: field.autosize,
              "show-password": field.showPassword,
              "prefix-icon": field.prefixIcon,
              resize: field.resize,
              onChange: val => {
                $options.commonChange(val, field);
              },
              onKeyup: _withKeys(() => {
                if (field.hasOwnProperty('keyupEnter')) field.keyupEnter();
              }, ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "size", "disabled", "readonly", "placeholder", "clearable", "maxlength", "minlength", "show-word-limit", "rows", "autosize", "show-password", "prefix-icon", "resize", "onChange", "onKeyup"])) : field.type === 'select' ? (_openBlock(), _createBlock(_component_el_select, {
              key: 1,
              modelValue: $setup.formData[field.name],
              "onUpdate:modelValue": $event => $setup.formData[field.name] = $event,
              size: field.size,
              disabled: field.disabled,
              readonly: field.readonly,
              placeholder: field.placeholder || `请选择${field.label}`,
              clearable: field.clearable,
              multiple: field.multiple,
              "reserve-keyword": field.reserveKeyword,
              "value-key": field.valueKey || 'value',
              filterable: field.filterable,
              remote: field.remote,
              "remote-method": query => {
                if (field.hasOwnProperty('remoteMethod')) field.remoteMethod(query, field);
              },
              loading: field.loading,
              "loading-text": field.loadingText,
              onChange: val => {
                $options.commonChange(val, field);
              }
            }, {
              default: _withCtx(() => [field.valueInLabel ? (_openBlock(true), _createElementBlock(_Fragment, {
                key: 0
              }, _renderList(field.items, ({
                label,
                value,
                disabled
              }, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: label,
                  value: {
                    label,
                    value
                  },
                  disabled: disabled
                }, null, 8, ["label", "value", "disabled"]);
              }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
                key: 1
              }, _renderList(field.items, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value,
                  disabled: item.disabled,
                  onClick: $event => $options.selectOptionClickChange(item, field)
                }, null, 8, ["label", "value", "disabled", "onClick"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "size", "disabled", "readonly", "placeholder", "clearable", "multiple", "reserve-keyword", "value-key", "filterable", "remote", "remote-method", "loading", "loading-text", "onChange"])) : ['date', 'week', 'month', 'year'].includes(field.type) ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 2,
              modelValue: $setup.formData[field.name],
              "onUpdate:modelValue": $event => $setup.formData[field.name] = $event,
              type: $options.datePickerType(field.type, field.range),
              size: field.size || 'small',
              disabled: field.disabled,
              readonly: field.readonly,
              placeholder: field.placeholder || `请选择${field.label}`,
              clearable: field.clearable,
              "picker-options": $options.pickerOptionsChange(field),
              "disabled-date": field.disabledDate,
              format: field.format || field.type === 'week' ? 'YYYY 第 WW 周' : undefined,
              "value-format": field.valueFormat || (field.type === 'date' ? $props.config.dateValueInTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD' : undefined),
              align: field.align,
              "end-placeholder": "结束日期",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              onChange: val => {
                $options.commonDateChange(val, field);
              }
            }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "size", "disabled", "readonly", "placeholder", "clearable", "picker-options", "disabled-date", "format", "value-format", "align", "onChange"])) : field.type === 'datetime' ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 3,
              modelValue: $setup.formData[field.name],
              "onUpdate:modelValue": $event => $setup.formData[field.name] = $event,
              type: field.range ? 'datetimerange' : 'datetime',
              size: field.size || 'small',
              disabled: field.disabled,
              readonly: field.readonly,
              placeholder: field.placeholder || `请选择${field.label}`,
              clearable: field.clearable,
              "picker-options": $options.pickerOptionsChange(field),
              format: field.format || 'YYYY-MM-DD HH:mm:ss',
              "value-format": field.valueFormat || 'YYYY-MM-DD HH:mm:ss',
              align: field.align,
              "end-placeholder": "结束日期",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              onChange: val => {
                $options.commonDateChange(val, field);
              }
            }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "size", "disabled", "readonly", "placeholder", "clearable", "picker-options", "format", "value-format", "align", "onChange"])) : field.type === 'cascader' ? (_openBlock(), _createBlock(_component_el_cascader, {
              key: 4,
              ref_for: true,
              ref: 'cascader' + fieldIndex,
              modelValue: $setup.formData[field.name],
              "onUpdate:modelValue": $event => $setup.formData[field.name] = $event,
              size: field.size,
              disabled: field.disabled,
              placeholder: field.placeholder || `请选择${field.label}`,
              clearable: field.clearable,
              options: field.items,
              props: field.props,
              "show-all-levels": field.showAllLevels,
              onChange: val => {
                $options.cascaderChange.call(this, val, field, fieldIndex);
              }
            }, null, 8, ["modelValue", "onUpdate:modelValue", "size", "disabled", "placeholder", "clearable", "options", "props", "show-all-levels", "onChange"])) : field.type === 'number' ? (_openBlock(), _createBlock(_component_el_input_number, {
              key: 5,
              modelValue: $setup.formData[field.name],
              "onUpdate:modelValue": $event => $setup.formData[field.name] = $event,
              min: field.min,
              max: field.max,
              precision: field.precision,
              controls: field.controls,
              "controls-position": field.controlsPosition,
              placeholder: field.placeholder || `请输入${field.label}`,
              onChange: val => {
                $options.commonChange(val, field);
              }
            }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "precision", "controls", "controls-position", "placeholder", "onChange"])) : field.type === 'phoneCascader' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 6
            }, [_createVNode(_component_van_field, {
              modelValue: $setup.formData[field.name + 'label'],
              "onUpdate:modelValue": $event => $setup.formData[field.name + 'label'] = $event,
              "is-link": "",
              readonly: "",
              placeholder: field.placeholder || `请选择${field.label}`,
              onClick: $event => $options.popupShowChange(true, field.name)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onClick"]), _createVNode(_component_van_popup, {
              show: $setup.popupShow[field.name],
              "onUpdate:show": $event => $setup.popupShow[field.name] = $event,
              round: "",
              position: "bottom"
            }, {
              default: _withCtx(() => [_createVNode(_component_van_cascader, {
                modelValue: $setup.formData[field.name],
                "onUpdate:modelValue": $event => $setup.formData[field.name] = $event,
                placeholder: field.placeholder || `请选择${field.label}`,
                options: field.items,
                "field-names": field.fieldNames || {
                  text: 'label',
                  value: 'value',
                  children: 'children'
                },
                onClose: $event => $options.popupShowChange(false, field.name),
                onFinish: val => {
                  $options.phoneCascaderFinish(val, field);
                }
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "options", "field-names", "onClose", "onFinish"])]),
              _: 2
            }, 1032, ["show", "onUpdate:show"])], 64)) : field.type === 'slot' ? _renderSlot(_ctx.$slots, field.name, {
              key: 7,
              data: {
                options: field
              }
            }, undefined, true) : _createCommentVNode("", true)], 2), field.intro ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(field.intro), 1)) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["label", "label-width", "prop"])]),
          _: 2
        }, 1032, ["span"])), [[_vShow, !field.hidden]]);
      }), 128))]),
      _: 3
    }, 8, ["gutter"])]),
    _: 3
  }, 8, ["model", "rules"])]);
}